import React, { useState } from 'react';
// import { useMutation } from '@apollo/react-hooks';
// import useLazyQuery from '../../../../../hooks/useLazyQuery';

import Dropdown from './components/Dropdown/Dropdown';

import arrowDownPurple from '../../../../../../assets/img/arrow-down-purple.svg';

import styles from './Consultancy.module.css';
import MultipleDropdown from './components/MultipleDropdown/MultipleDropdown';
import {
  CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING,
  CONSULTANCY_VALIDATION_SUPPORT_MAPPING
} from '../../../SurveyBuilder/helpers/constants';

export default ({ survey, onUpdate }) => {
  const [expanded, setExpanded] = useState(true);

  const otherOnDemandServicesSelectedValueArray =
    survey &&
    survey.additionalBudgetCost &&
    survey.additionalBudgetCost.consultancy &&
    survey.additionalBudgetCost.consultancy.otherOnDemandServices &&
    survey.additionalBudgetCost.consultancy.otherOnDemandServices.map(
      s => CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING[s]
    );
  const otherOnDemandServicesSelectedValue =
    otherOnDemandServicesSelectedValueArray &&
    otherOnDemandServicesSelectedValueArray.length &&
    otherOnDemandServicesSelectedValueArray.toString().substring(0, 150);

  const removeTypenameFromPayload = payload => {
    const newPayload = { ...payload };

    delete newPayload.__typename;
    if (newPayload.consultancy) {
      delete newPayload.consultancy.__typename;
    }

    return newPayload;
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.titleContainer}
        role="presentation"
        onClick={() => setExpanded(() => setExpanded(!expanded))}
      >
        <div className={styles.title}>Consultancy</div>
        <img
          src={arrowDownPurple}
          alt="ExpandColapse"
          className={expanded ? styles.arrowExpanded : styles.arrowCollapsed}
        />
      </div>
      {expanded ? (
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={styles.rowText}>Validation support</div>
            <div>
              <Dropdown
                selectedValue={
                  survey &&
                  survey.additionalBudgetCost &&
                  survey.additionalBudgetCost.consultancy &&
                  survey.additionalBudgetCost.consultancy.validationSupport &&
                  CONSULTANCY_VALIDATION_SUPPORT_MAPPING[
                    survey.additionalBudgetCost.consultancy.validationSupport
                  ]
                }
                onSelectCompleted={async value => {
                  const newAdditionalBudgetCost = removeTypenameFromPayload(
                    survey.additionalBudgetCost
                  );
                  newAdditionalBudgetCost.consultancy.validationSupport = value;
                  onUpdate('additionalBudgetCost', newAdditionalBudgetCost);
                }}
                searchEnabled={false}
                options={Object.keys(
                  CONSULTANCY_VALIDATION_SUPPORT_MAPPING
                ).map(k => ({
                  value: k,
                  label: CONSULTANCY_VALIDATION_SUPPORT_MAPPING[k]
                }))}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.rowText}>Other on demand services</div>
            <div>
              <MultipleDropdown
                selectedValue={
                  otherOnDemandServicesSelectedValue &&
                  otherOnDemandServicesSelectedValue.length === 150
                    ? `${otherOnDemandServicesSelectedValue}...`
                    : otherOnDemandServicesSelectedValue
                }
                findList={
                  survey &&
                  survey.additionalBudgetCost &&
                  survey.additionalBudgetCost.consultancy &&
                  survey.additionalBudgetCost.consultancy.otherOnDemandServices
                }
                onSelectCompleted={async value => {
                  const newAdditionalBudgetCost = removeTypenameFromPayload(
                    survey.additionalBudgetCost
                  );

                  if (
                    newAdditionalBudgetCost &&
                    newAdditionalBudgetCost.consultancy &&
                    newAdditionalBudgetCost.consultancy.otherOnDemandServices &&
                    newAdditionalBudgetCost.consultancy.otherOnDemandServices.indexOf(
                      value
                    ) > -1
                  ) {
                    const withoutValue = newAdditionalBudgetCost.consultancy.otherOnDemandServices.filter(
                      s => s !== value
                    );
                    newAdditionalBudgetCost.consultancy.otherOnDemandServices = withoutValue;
                  } else {
                    newAdditionalBudgetCost.consultancy.otherOnDemandServices = [
                      ...newAdditionalBudgetCost.consultancy
                        .otherOnDemandServices,
                      value
                    ];
                  }

                  onUpdate('additionalBudgetCost', newAdditionalBudgetCost);
                }}
                multipleChoice
                fetchOptions={() =>
                  Object.keys(CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING).map(
                    k => ({
                      value: k,
                      label: CONSULTANCY_OTHER_ON_DEMAND_SERVICES_MAPPING[k]
                    })
                  )
                }
                loading={false}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
